import {BaseService} from "./BaseService.ts";
import {CreateAuthConfigRequest} from "../model/request/authConfig/CreateAuthConfigRequest.ts";

export class AuthConfigService {
    static create = (others: any, data: CreateAuthConfigRequest) => {
        return BaseService.apiClient(others).post("/authentication-config/create", data);
    };

}